var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSol = function SvgSol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sol_svg__a)",
    d: "M15.957 8A7.958 7.958 0 1 1 .04 8a7.958 7.958 0 0 1 15.916 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.962 9.883a.3.3 0 0 1 .208-.086h7.182c.132 0 .197.159.105.252l-1.42 1.418a.3.3 0 0 1-.207.086H3.648a.147.147 0 0 1-.105-.25zM4.962 4.586A.3.3 0 0 1 5.17 4.5h7.182c.132 0 .197.158.105.251l-1.42 1.419a.3.3 0 0 1-.207.086H3.648a.147.147 0 0 1-.105-.251zM11.038 7.217a.3.3 0 0 0-.208-.086H3.648a.147.147 0 0 0-.105.252L4.963 8.8a.3.3 0 0 0 .207.086h7.182a.147.147 0 0 0 .105-.25z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__a",
    x1: 7.999,
    x2: 7.999,
    y1: 0.042,
    y2: 15.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DF2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D725FD"
  })))));
};
export default SvgSol;